(function($){

	var parallax = function(el, container, throttle) {
		if(!el.length || !container.length) {
			return;
		}
		$.each(el, function() {
			var zIndex = parseInt($(this).css('z-index'));
			var pageBottom = $(window).scrollTop() + $(window).innerHeight();
			var start = $(container).offset().top;
			var stop = $(container).offset().top + $(container).innerHeight() + $(window).innerHeight();
			var transform = pageBottom * (zIndex / throttle);
			if(zIndex % 2 == 0) {
				transform = transform * -1;
			}
			$(this).css('transform', 'translateY(' + transform + '%)');
		});
	};

	var waterDrops = function() {
		var cont = $('.featured-collections__list');
		var drops = $('.featured-collections__drops');
		$(window).on('scroll load', function() {
			parallax(drops, cont, 70);
		});
	};

	var ocnOverflow = function() {
		function ocnHeightCheck(){
			var proportionOfChildrenTotal = 1.5;
			var ocnHeight = $('#ocn-inner').height() + $('.ocn-social').height() + $('ocn-cart-container').height();
			var value = ocnHeight <= $(window).height() / proportionOfChildrenTotal ? 'initial' : 'scroll';
			console.log( ocnHeight );
			console.log( $(window).height() );
			$('#ocn').css('overflow', value);
		}
		ocnHeightCheck();
		optimizedResize.add(ocnHeightCheck);
	};

	$(document).ready(function(){
		ocnOverflow();
		waterDrops();
	});

})(jQuery);